module.exports = __webpack_public_path__ + "media/images/logo_slide-ded1bd7a5673da60e9ef16eb5df2a27a.png";